function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/**
 * Request headers compilation
 *
 * @param  {Object} state - application state
 * @param  {Object} [customHeaders = {}] - custom request headers
 * @return {Object} - compiled headers
 */
export default function compileHeaders(state) {
  var customHeaders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var authorizationToken = state.persistence.authorizationToken;
  var stubVariants = state.persistence.stub_variants;
  var headers = _objectSpread({
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }, customHeaders);
  if (authorizationToken) headers.Authorization = "Basic ".concat(authorizationToken);
  if (stubVariants) {
    var stubCookie = "stub_variants=".concat(stubVariants);
    headers.Cookie = !headers.Cookie ? stubCookie : "".concat(stubCookie, "; ").concat(headers.Cookie);
  }
  return headers;
}